import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/1298a009-39f3-4638-8ec9-675b12e2be91";
export const REGISTER_URL = "https://a.ntrk2.com/e8d61a40-a1db-409e-b391-1fd5bc02ebbb";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://268mama.kzw2a.com/download?openExternalBrowser=1&id=vjwcvhlle0xeaax";

export * from "./codes";
export * from "./context";
